import * as Yup from 'yup';

 const JobValidationSchema = Yup.object().shape({
    startDate: Yup.date()
      .required('From date is required')  // Ensures startDate is provided
      .typeError('From date must be a valid date'),  // Ensures the startDate is a valid date

    endDate: Yup.date()
      .required('To date is required')  // Ensures endDate is provided
      .typeError('To date must be a valid date')  // Ensures the endDate is a valid date
      .test('is-greater-than-start', 'To date cannot be earlier than From date', function (value) {
        const { startDate } = this.parent;  // Get the startDate from the parent object
        if (startDate && value && new Date(startDate) > new Date(value)) {
          return false;  // If startDate is greater than endDate, validation fails
        }
        return true;  // Validation passes if no issue
      }),
  });

export { JobValidationSchema }